interface ActionTypes {
  GET_ORGANISATIONS_START: string;
  GET_ORGANISATIONS_SUCCESS: string;
  GET_ORGANISATIONS_FAILURE: string;
  GET_ORGANISATIONS_RESET: string;
  GET_ORGANISATION_DETAIL_START: string;
  GET_ORGANISATION_DETAIL_SUCCESS: string;
  GET_ORGANISATION_DETAIL_FAILURE: string;
  GET_ORGANISATION_DETAIL_RESET: string;
  GET_ORGANISATION_GROUPS_START: string;
  GET_ORGANISATION_GROUPS_SUCCESS: string;
  GET_ORGANISATION_GROUPS_FAILURE: string;
  UPDATE_ORGANISATION_START: string;
  UPDATE_ORGANISATION_SUCCESS: string;
  UPDATE_ORGANISATION_FAILURE: string;
  UPDATE_ORGANISATION_RESET: string;
  UPDATE_MULTI_ORGANISATIONS_START: string;
  UPDATE_MULTI_ORGANISATIONS_SUCCESS: string;
  UPDATE_MULTI_ORGANISATIONS_FAILURE: string;
  UPDATE_MULTI_ORGANISATIONS_RESET: string;
  CREATE_ORGANISATION_START: string;
  CREATE_ORGANISATION_SUCCESS: string;
  CREATE_ORGANISATION_FAILURE: string;
  CREATE_ORGANISATION_RESET: string;
  GET_ORGANISATION_UPDATE_LOGS_START: string;
  GET_ORGANISATION_UPDATE_LOGS_SUCCESS: string;
  GET_ORGANISATION_UPDATE_LOGS_FAILURE: string;
  GET_ORGANISATION_UPDATE_LOGS_RESET: string;
  SUSPEND_ORGANISATION_START: string;
  SUSPEND_ORGANISATION_SUCCESS: string;
  SUSPEND_ORGANISATION_FAILURE: string;
  GET_ORGANISATION_TRANSACTION_LIMITS_START: string;
  GET_ORGANISATION_TRANSACTION_LIMITS_SUCCESS: string;
  GET_ORGANISATION_TRANSACTION_LIMITS_FAILURE: string;
  ADD_ORGANISATION_TRANSACTION_LIMITS_START: string;
  ADD_ORGANISATION_TRANSACTION_LIMITS_SUCCESS: string;
  ADD_ORGANISATION_TRANSACTION_LIMITS_FAILURE: string;
  ADD_ORGANISATION_TRANSACTION_LIMITS_RESET: string;
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_START: string;
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_SUCCESS: string;
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_FAILURE: string;
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_RESET: string;
}

export const SysAdminOrgActionTypes: ActionTypes = {
  GET_ORGANISATIONS_START: '@@GET_ORGANISATIONS_START',
  GET_ORGANISATIONS_SUCCESS: '@@GET_ORGANISATIONS_SUCCESS',
  GET_ORGANISATIONS_FAILURE: '@@GET_ORGANISATIONS_FAILURE',
  GET_ORGANISATIONS_RESET: '@@GET_ORGANISATIONS_RESET',
  GET_ORGANISATION_DETAIL_START: '@@GET_ORGANISATION_DETAIL_START',
  GET_ORGANISATION_DETAIL_SUCCESS: '@@GET_ORGANISATION_DETAIL_SUCCESS',
  GET_ORGANISATION_DETAIL_FAILURE: '@@GET_ORGANISATION_DETAIL_FAILURE',
  GET_ORGANISATION_DETAIL_RESET: '@@GET_ORGANISATION_DETAIL_RESET',
  GET_ORGANISATION_GROUPS_START: '@@GET_ORGANISATION_GROUPS_START',
  GET_ORGANISATION_GROUPS_SUCCESS: '@@GET_ORGANISATION_GROUPS_SUCCESS',
  GET_ORGANISATION_GROUPS_FAILURE: '@@GET_ORGANISATION_GROUPS_FAILURE',
  UPDATE_ORGANISATION_START: '@@UPDATE_ORGANISATION_START',
  UPDATE_ORGANISATION_SUCCESS: '@@UPDATE_ORGANISATION_SUCCESS',
  UPDATE_ORGANISATION_FAILURE: '@@UPDATE_ORGANISATION_FAILURE',
  UPDATE_ORGANISATION_RESET: '@@UPDATE_ORGANISATION_RESET',
  UPDATE_MULTI_ORGANISATIONS_START: '@@UPDATE_MULTI_ORGANISATIONS_START',
  UPDATE_MULTI_ORGANISATIONS_SUCCESS: '@@UPDATE_MULTI_ORGANISATIONS_SUCCESS',
  UPDATE_MULTI_ORGANISATIONS_FAILURE: '@@UPDATE_MULTI_ORGANISATIONS_FAILURE',
  UPDATE_MULTI_ORGANISATIONS_RESET: '@@UPDATE_MULTI_ORGANISATIONS_RESET',
  CREATE_ORGANISATION_START: '@@CREATE_ORGANISATION_START',
  CREATE_ORGANISATION_SUCCESS: '@@CREATE_ORGANISATION_SUCCESS',
  CREATE_ORGANISATION_FAILURE: '@@CREATE_ORGANISATION_FAILURE',
  CREATE_ORGANISATION_RESET: '@@CREATE_ORGANISATION_RESET',
  GET_ORGANISATION_UPDATE_LOGS_START: '@@GET_ORGANISATION_UPDATE_LOGS_START',
  GET_ORGANISATION_UPDATE_LOGS_SUCCESS:
    '@@GET_ORGANISATION_UPDATE_LOGS_SUCCESS',
  GET_ORGANISATION_UPDATE_LOGS_FAILURE:
    '@@GET_ORGANISATION_UPDATE_LOGS_FAILURE',
  GET_ORGANISATION_UPDATE_LOGS_RESET: '@@GET_ORGANISATION_UPDATE_LOGS_RESET',
  GET_ORGANISATION_TRANSACTION_LIMITS_START:
    '@@GET_ORGANISATION_TRANSACTION_LIMITS_START',
  GET_ORGANISATION_TRANSACTION_LIMITS_SUCCESS:
    '@@GET_ORGANISATION_TRANSACTION_LIMITS_SUCCESS',
  GET_ORGANISATION_TRANSACTION_LIMITS_FAILURE:
    '@@GET_ORGANISATION_TRANSACTION_LIMITS_FAILURE',
  ADD_ORGANISATION_TRANSACTION_LIMITS_START:
    '@@ADD_ORGANISATION_TRANSACTION_LIMITS_START',
  ADD_ORGANISATION_TRANSACTION_LIMITS_SUCCESS:
    '@@ADD_ORGANISATION_TRANSACTION_LIMITS_SUCCESS',
  ADD_ORGANISATION_TRANSACTION_LIMITS_FAILURE:
    '@@ADD_ORGANISATION_TRANSACTION_LIMITS_FAILURE',
  ADD_ORGANISATION_TRANSACTION_LIMITS_RESET:
    '@@ADD_ORGANISATION_TRANSACTION_LIMITS_RESET',
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_START:
    '@@REMOVE_ORGANISATION_TRANSACTION_LIMITS_START',
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_SUCCESS:
    '@@REMOVE_ORGANISATION_TRANSACTION_LIMITS_SUCCESS',
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_FAILURE:
    '@@REMOVE_ORGANISATION_TRANSACTION_LIMITS_FAILURE',
  REMOVE_ORGANISATION_TRANSACTION_LIMITS_RESET:
    '@@REMOVE_ORGANISATION_TRANSACTION_LIMITS_RESET',
  SUSPEND_ORGANISATION_START: '@@SUSPEND_ORGANISATION_START',
  SUSPEND_ORGANISATION_SUCCESS: '@@SUSPEND_ORGANISATION_SUCCESS',
  SUSPEND_ORGANISATION_FAILURE: '@@SUSPEND_ORGANISATION_FAILURE'
};

export interface SysAdminOrgState {
  organisations?: { count: number; data: any[] };
  organisationDetail?: any;
  organisationGroups: any[];
  createOrgsStatus: 'initial' | 'creating' | 'success' | 'failed';
  createOrgsError?: string;
  getOrgsStatus: 'initial' | 'fetching' | 'success' | 'failed';
  updateMultiOrgsStatus: 'initial' | 'updating' | 'success' | 'failed';
  getOrgDetailStatus: 'initial' | 'fetching' | 'success' | 'failed';
  getOrgGroupsStatus: 'initial' | 'fetching' | 'success' | 'failed';
  updateOrgStatus: 'initial' | 'updating' | 'success' | 'failed';
  updateOrgError?: string;
  reloadTrigger: number;
  getOrgUpdateLogsStatus: 'initial' | 'fetching' | 'success' | 'failed';
  organisationUpdateLogs?: { count: number; data: any[] };
  suspendOrgStatus: 'initial' | 'suspending' | 'success' | 'failed';
  suspendOrgError?: string;
  getOrgTransactionLimitsStatus?: 'initial' | 'fetching' | 'success' | 'failed';
  addOrgTransactionLimitsStatus?: 'initial' | 'updating' | 'success' | 'failed';
  removeOrgTransactionLimitsStatus?:
    | 'initial'
    | 'removing'
    | 'success'
    | 'failed';
  organisationTransactionLimits?: { count: number; data: any[] };
}
